import { datadogRum } from '@datadog/browser-rum';

export const datadogInit = config => {
  const { version, datadog } = config;
  if (datadog.enabled) {
    datadogRum.init({
      ...datadog,
      site: 'datadoghq.com',
      trackInteractions: true,
      env: 'production',
      version,
    });
  }
};
